import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { isCentimeters } from '../../../../../../services/unit-services/dimensions/dimension-type-service';
import { messages } from '../messages';

import type { DimensionUnit } from '../../../../../../prop-types/dimenstion-unit';

type WidthCellProps = {
  value: number;
};

export const WidthCell = ({ value }: WidthCellProps) => {
  const limitedValue = parseFloat(value.toFixed(2));
  return <Text textType={TextType.Paragraph} value={limitedValue} />;
};

type HeaderCellProps = {
  sellerDefaultDimensionsUnit: DimensionUnit;
};

export const HeaderCell = ({ sellerDefaultDimensionsUnit }: HeaderCellProps) => {
  const unitMessage = useMemo(
    () => (isCentimeters(sellerDefaultDimensionsUnit) ? messages.cm : messages.in),
    [sellerDefaultDimensionsUnit],
  );

  return (
    <FormattedMessage
      {...messages.widthColumnHeader}
      values={{
        unit: <FormattedMessage {...unitMessage} />,
      }}
    />
  );
};
